// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","flexContainer":"Navbar_flexContainer__3XmW7","btndark":"Navbar_btndark__K68pJ"};